import { render, staticRenderFns } from "./PlatformTextField.vue?vue&type=template&id=03820402&scoped=true"
import script from "./PlatformTextField.vue?vue&type=script&lang=ts"
export * from "./PlatformTextField.vue?vue&type=script&lang=ts"
import style0 from "./PlatformTextField.vue?vue&type=style&index=0&id=03820402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03820402",
  null
  
)

export default component.exports